/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-12-18 13:24:04
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbReport {
    /**
     * 销售报表
     */
    export var GetTbSaleReportList = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTbSaleReportList`, body);
    };
    /**
     * 销售报表合计
     */
    export var GetTbSaleReportTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTbSaleReportTotal`, body);
    };
    /**
     * 会员积分明细
     */
    export var GetMemberScoreReport = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetMemberScoreReport`, body);
    };
    /**
     * 会员积分明细合计
     */
    export var GetMemberScoreTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetMemberScoreTotal`, body);
    };
    /**
     * 交易总览
     */
    export var GetTransactionOverview = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTransactionOverview`, body);
    };
    /**
     * 交易总览合计
     */
    export var GetTransactionOverviewTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetTransactionOverviewTotal`, body);
    };
    /**
     * 支付总览
     */
    export var GetPaymentOverview = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetPaymentOverview`, body);
    };
    /**
     * 支付总览合计
     */
    export var GetPaymentOverviewTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetPaymentOverviewTotal`, body);
    };
    /**
     * 员工总览
     */
    export var GetEmployeeOverview = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetEmployeeOverview`, body);
    };
    /**
     * 商品报表
     */
    export var GetOrderItemReport = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetOrderItemReportNew_V2`, body);
    };
    /**
     * 商品报表合计
     */
    export var GetOrderItemTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetOrderItemTotalNew_V2`, body);
    };
    /**
     * 商品交易明细
     */
    export var GetGoodsSalesDetails = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetGoodsSalesDetails`, body);
    };
    /**
     * 会员交易明细
     */
    export var GetMemberTradeReport = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetMemberTradeReport`, body);
    };
    /**
     * 会员充值明细
     */
    export var GetMemberRechargeReport = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetMemberRechargeReport`, body);
    };
    /**
     * 会员积分明细
     */
    export var GetMemberScoreReport = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetMemberScoreReport`, body);
    };
    /**
     * 员工月度提成
     */
    export var GetAccountReportList = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetAccountReportList`, body);
    };
    /**
     * 员工售出商品列表
     */
    export var GetSellingGoodsList = (body: any): Promise<any> => {
        return Get(`/api/TbReport/GetSellingGoodsList`, body);
    };




}



// WEBPACK FOOTER //
// ./src/http/api_TbReport.ts